import axios from "axios";
import { toast } from "react-toastify";
import { baseUrl, getHeader } from "../utils/api";

/**
 * Create a Stripe checkout session for a book donation
 * @param {Object} donationData
 * @returns {Promise<Object>}
 */
export const createBookDonationSession = async (donationData) => {
  try {
    const header = await getHeader();
    const response = await axios.post(
      `${baseUrl}/book-donation/create-checkout-session`,
      donationData,
      {
        headers: header,
      }
    );
    if (response?.status === 200 || response?.status === 201) {
      return response.data;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error("Failed to initiate payment session. Please try again.");
    }
    throw error;
  }
};

/**
 * Get all book donations with optional filters/pagination
 * @param {Object} params
 * @returns {Promise<Object>}
 */
export const getBookDonations = async (params = {}) => {
  try {
    const header = await getHeader();
    const response = await axios.get(`${baseUrl}/book-donation`, {
      headers: header,
      params,
    });
    if (response?.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error("Failed to fetch book donations.");
    }
    throw error;
  }
};

/**
 * Get a single book donation by ID
 * @param {string} donationId
 * @returns {Promise<Object>}
 */
export const getBookDonationById = async (donationId) => {
  try {
    const header = await getHeader();
    const response = await axios.get(`${baseUrl}/book-donation/${donationId}`, {
      headers: header,
    });
    if (response?.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error("Failed to fetch book donation details.");
    }
    throw error;
  }
};

